import Services from '@/services/index';
import VT from '@/store/types';
import { Backend } from '@/_axios';
import router from '@/router';

export default {
  [VT.LOGIN]: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      const service = data.tv
        ? Services.auth.tvLogin
        : data.oauth
          ? Services.auth.oAuthLogin
          : Services.auth.login;
      // console.log('VT.LOGIN');
      service(data).then(({ data }) => {
        commit(VT.SET_AUTH_TOKEN, data.access_token);
        Backend.defaults.headers.common['Authorization'] = `Bearer ${data.access_token}`;
        commit(VT.SET_AUTH_INFO, data);
        if (data.refresh_token) {
          commit(VT.SET_REFRESH_TOKEN, data.refresh_token);
        }
        // set first user project as default
        // if (data.user.user.project_users.length) {
        //   commit(VT.SET_ACTIVE_PROJECT, data.user.user.project_users[0].project.id);
        // }
        resolve();
      }, () => {
        reject();
      });
    });
  },

  [VT.LOAD_USER_INFO]: ({ commit }) => {
    return new Promise((resolve, reject) => {
      Services.auth.userWithProject().then(({ data }) => {
        commit(VT.SET_AUTH_INFO, data);
        resolve();
      }).catch((errResponse) => {
        console.log(errResponse);
        reject();
      });
    });
  },
  [VT.LOGOUT]: ({ commit }, { redirect } = { redirect: true }) => {
    return new Promise((resolve) => {
      commit('RESET_TO_DEFAULT_STATE', [], { root: true });

      if (redirect) {
        router.replace({ name: 'Login' }).catch(() => {});
      }
      resolve();
    });
  },
  [VT.UPDATE_AUTH_TOKEN]: ({ commit }, token) => {
    return new Promise((resolve) => {
      commit(VT.SET_AUTH_TOKEN, token);
      Backend.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      resolve();
    });
  },

  [VT.REFRESH_AUTH_TOKEN]: ({ commit, getters }) => {
    if (!getters['refreshTokenValid'](10)) return Promise.reject();
    return new Promise((resolve) => {
      Services.auth.refresh(getters['refreshToken']).then(({ data }) => {
        commit(VT.SET_AUTH_TOKEN, data.access_token);
        Backend.defaults.headers.common['Authorization'] = `Bearer ${data.access_token}`;
        resolve(data.access_token);
      });
    });
  },
};
